module.exports = (url, baseUrl) => {
  const isAbsoluteUrl = /^https?:\/\//i.test(url);
  /* eslint-disable no-script-url */
  const footerUrl = (isAbsoluteUrl || url.includes('javascript:')) ? url : `${baseUrl}${url}`;
  return footerUrl;
};



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/Polaris/header-footer-wgl/polaris_deploy_header-footer-wgl_deployable_pipeline/package/node_modules/@feature/footer/src/helpers/getAbsoluteUrl.js